import config from 'config';
import * as http from 'utils/http';

export const AVAILABLE_TOOGLE_URL = `${config.API_URL}staff_users/`;

export async function toggleAvailability(user) {
  try {
    return await http.patch(`${AVAILABLE_TOOGLE_URL}${user.id}/`, {
      ...user,
      available: !user.available,
    });
  } catch (e) {
    console.error(e);
  }
}
